const map = {
	"./BTL/fondo.png": 9417,
	"./Branding/fondo.png": 5172,
	"./Marketing/fondo.png": 1451,
	"./Produccion/fondo.png": 717,
	"./Trade/fondo.png": 1685
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 386;